import { useContext } from 'react';
import { CheckIcon } from '@heroicons/react/24/solid';
import jsonProgress from '../data/progress.json';
import { EnglishSpanishText, ProgressSteps } from './types';
import { FinancialStatusContext } from './context/financial-status-context';

const progressSteps = jsonProgress as ProgressSteps; // Type the data

export default function ProgressIndicator() {
	const financialContext = useContext(FinancialStatusContext);
	const renderProgress = (step: EnglishSpanishText, index: number) => {
		return (
			<div className="my-1 flex items-center">
				<div>{renderBubble(step, index)}</div>
				<div>{renderText(step, index)}</div>
			</div>
		);
	};

	const renderBubble = (step: EnglishSpanishText, index: number) => {
		const isValidated = financialContext.validatedSteps.includes(step.en);
		const isCurrent = financialContext.currentStep === index;

		let bubbleContent;
		let bubbleClassNames = 'flex h-5 w-5 items-center justify-center rounded-full border-2 ';

		if (isValidated) {
			bubbleClassNames += 'border-green-500';
			bubbleContent = (
				<div className="flex h-5 w-5 items-center justify-center rounded-full bg-green-500">
					<CheckIcon className="h-4 w-4 text-white" />
				</div>
			);
		} else if (isCurrent) {
			bubbleClassNames += 'border-gray-500';
			bubbleContent = <span className="h-5 w-5 rounded-full bg-transparent" />;
		} else {
			bubbleClassNames += 'border-gray-100';
			bubbleContent = <span className="h-5 w-5 rounded-full bg-gray-100" />;
		}

		return (
			<div className="">
				<div className={bubbleClassNames}>{bubbleContent}</div>
			</div>
		);
	};

	const renderSeparator = (step: EnglishSpanishText, index: number) => {
		return (
			<div className="flex w-5 max-w-5 items-center justify-center">
				{index !== progressSteps.length - 1 ? (
					<div
						className={`${financialContext.validatedSteps.includes(step.en) ? 'bg-green-500' : 'bg-gray-100'} h-4 w-[1px]`}
					/>
				) : null}
			</div>
		);
	};

	const renderText = (step: EnglishSpanishText, index: number) => {
		const isCurrent = financialContext.currentStep === index;
		const isValidated = financialContext.validatedSteps.includes(step.en);
		let textClassName;

		if (isCurrent) {
			textClassName = 'text-gray-600 font-semibold';
		} else if (isValidated) {
			textClassName = 'text-gray-500';
		} else {
			textClassName = 'text-gray-300';
		}

		return (
			<div className="w-fit">
				<div className={`ml-2 ${textClassName}`}>{financialContext.language === 'en' ? step.en : step.es}</div>
			</div>
		);
	};

	return (
		<div>
			{progressSteps.map((step, index) => (
				<div className="items-center" key={step.en}>
					{renderProgress(step, index)}
					{renderSeparator(step, index)}
				</div>
			))}
		</div>
	);
}
